import React, { useEffect, useState, useRef } from "react";
import { Container, Table, Button, Form, InputGroup } from "react-bootstrap";
import ReporteMaquinaria from "./ReporteMaquinaria";
import API_BASE from "../api"; // ✅ Importar URL base

function ListarReportes() {
  const [reportes, setReportes] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [reporteSeleccionado, setReporteSeleccionado] = useState(null);
  const printRef = useRef();

  // Obtener los reportes del backend
  const cargarReportes = () => {
    fetch(`${API_BASE}/reportes`) // ✅ Usar API_BASE aquí
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setReportes(data);
        } else {
          console.error("Respuesta inesperada:", data);
        }
      })
      .catch((error) => {
        console.error("Error al obtener reportes:", error);
      });
  };

  useEffect(() => {
    cargarReportes();
  }, []);

  // Filtrar según texto ingresado
  const reportesFiltrados = reportes.filter((r) =>
    Object.values(r).some((v) =>
      String(v).toLowerCase().includes(filtro.toLowerCase())
    )
  );

  // Eliminar reporte
  const eliminarReporte = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este reporte?")) return;
    try {
      await fetch(`${API_BASE}/reportes/${id}`, {
        method: "DELETE",
      });
      cargarReportes(); // Refrescar lista
      setReporteSeleccionado(null);
    } catch (error) {
      alert("❌ Error al eliminar: " + error.message);
    }
  };

  // Imprimir
  const imprimirReporte = () => {
    const printContent = printRef.current.innerHTML;
    const newWindow = window.open("", "_blank", "width=800,height=600");
    newWindow.document.write(`
      <html>
        <head>
          <title>Reporte Maquinaria</title>
          <style>
            body { font-family: Arial; padding: 20px; }
            h2, h4 { text-align: center; }
            table { width: 100%; border-collapse: collapse; }
            td, th { padding: 6px; border: 1px solid #000; }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    newWindow.document.close();
    newWindow.onload = () => {
      newWindow.print();
      newWindow.close();
    };
  };

  return (
    <Container style={{ maxWidth: 1000, padding: 20 }}>
      <h3 className="mb-4">📁 Reportes Guardados</h3>

      <InputGroup className="mb-3">
        <Form.Control
          placeholder="Buscar por cualquier campo..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
        />
      </InputGroup>

      {reportesFiltrados.length === 0 ? (
        <p>No se encontraron reportes.</p>
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>N° Reporte</th>
              <th>Empresa</th>
              <th>Máquina</th>
              <th>Obra</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {reportesFiltrados.map((r) => (
              <tr key={r._id}>
                <td>{r.fecha}</td>
                <td>{r.numero}</td>
                <td>{r.empresa}</td>
                <td>{r.maquina}</td>
                <td>{r.obra}</td>
                <td>
                  <div className="d-flex gap-2">
                    <Button variant="info" size="sm" onClick={() => setReporteSeleccionado(r)}>
                      Ver
                    </Button>
                    <Button variant="danger" size="sm" onClick={() => eliminarReporte(r._id)}>
                      Eliminar
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {reporteSeleccionado && (
        <div className="mt-5">
          <h4>📝 Detalle del Reporte</h4>
          <div ref={printRef}>
            <ReporteMaquinaria datos={reporteSeleccionado} />
          </div>
          <Button variant="secondary" className="mt-3" onClick={imprimirReporte}>
            🖨️ Imprimir
          </Button>
        </div>
      )}
    </Container>
  );
}

export default ListarReportes;
